import axios from "../utils/axios";

function request(functionId, body) {
  let data = {
    functionId,
    body
  };
  return axios.request({
    data: data,
    method: "post"
  });
}

// 获取内容索引数据-树形 接口文档：https://cf.jd.com/pages/viewpage.action?pageId=1160638818
export function manListContentIndexTree (body) {
  return request('health_cmp_biz_manListContentIndexTree', {...body, appid: 'health-bianque-man'});
}
export function writerContentIndexTree (body) {
  return request('health_cmp_biz_writerContentIndexTree', body);
}
// 查询圈子列表 https://joyspace.jd.com/pages/Ngk0w0ZE1SUXfAaybaGY
export function qzManPage (body) {
  return request('jdh_qz_man_page', body);
}
// 批量修改帖子所属圈子,https://joyspace.jd.com/pages/MbGXYzLs1j5P2xJs22IH
export function changeCommunity (body) {
  return request('jdh_qz_man_post_change_community', body);
}

// 圈子列表查询,https://joyspace.jd.com/pages/hEzS94v4Vq1TNgRwIpVn
export function jdh_community_list (body) {
  return request('jdh_community_list', body);
}

// 批量修改帖子状态,https://joyspace.jd.com/pages/JbcWT9mCuCF9pB4K7HGE
export function jdh_qz_man_post_change (body) {
  return request('jdh_qz_man_post_change', body);
}

export function jdh_qz_man_update_post_top_score (body) {
  return request('jdh_qz_man_update_post_top_score', body);
}

export function jdh_qz_man_update_post_featured_score (body) {
  return request('jdh_qz_man_update_post_featured_score', body);
}

export function changeKKComment (body) {
  return request('jdh_qz_man_update_kangkang_comment', body);
}
export function jdh_qz_man_activity_bu_post_relation(body) {
  return request('jdh_qz_man_activity_bu_post_relation', body);
}
export function subject_auditPostQuality(body) {
  return request('subject_auditPostQuality', body);
}